<template>
  <div class="container">
    <div class="container" v-if="loading">
      <div class="row">
        <div class="loading-sm"></div>
      </div>
    </div>
    <div v-else class="detail-card" :key="componentKey">
      <h6 style="margin-left:1px;">Store Rewards </h6>
      <!-- <div class="card card-flat-pad card-striped"></div> -->
      <div v-for="reward_type in sellpoint.reward_settings" :key="reward_type.reward_type_id">
        <div v-if="(reward_type.reward_type_id == 2)"><!--just-picking-refer-buyer-->
          <p><b>{{reward_type.reward_type_name}} Reward</b></p>
                      <p class="p-tiny-info">{{reward_type.reward_type_descr}}</p>
                      <div v-if="reward_type.reward_type_is_set">
                        <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('edit'+reward_type.reward_type_name+reward_type.reward_type_id)" style="float: right;">Edit</a>
                        <p><b>Reward: 
                          <span v-if="reward_type.reward_type_setting.reward_set_amount_type == 'C'">₦</span><span v-if="reward_type.reward_type_setting.reward_set_amount">{{reward_type.reward_type_setting.reward_set_amount}}</span>
                          <span v-if="reward_type.reward_type_setting.reward_set_amount_type == 'P'">%</span>
                        </b></p>
                      </div>
                      <div v-else>
                        <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('set'+reward_type.reward_type_name+reward_type.reward_type_id)" style="float: right;">SET</a>
                        <p style="color:#ff0000; font-size:13px;">No reward set</p>
                      </div>
                      <div v-if="menu_tab_inner_view['set'+reward_type.reward_type_name+reward_type.reward_type_id] || menu_tab_inner_view['edit'+reward_type.reward_type_name+reward_type.reward_type_id]">
                        <h6 class="margin-t-40">Set a Reward for {{reward_type.reward_type_name}} </h6>
                          <!-- <div v-if="sellpoint.business_agent_commission"> -->
                            <form class="sp-form" style="padding-left:0">
                              <label><b>Reward Amount: <span v-if="reward_type.reward_type_setting.reward_set_amount">{{reward_type.reward_type_setting.reward_set_amount}}</span></b>
                              <div style="display: flex;flex-flow: row wrap;align-items: center;" v-if="menu_tab_inner_view['set'+reward_type.reward_type_name+reward_type.reward_type_id]">
                                <input type="number" class="form-control" v-model="business_details.set_reward_type_amount" style="width: 25%; margin-right: 5px;" />
                                <select class="sp-form-select form-control" v-model="set_reward_type_amount_type" style="width: 45%;">
                                  <option value="P">% (percentage)</option>
                                  <option value="C">₦ (cash)</option>
                                </select>
                              </div>
                              <div style="display: flex;flex-flow: row wrap;align-items: center;" v-else>
                                <input type="number" class="form-control" v-model="reward_type.reward_type_setting.reward_set_amount" style="width: 25%; margin-right: 5px;" />
                                <select class="sp-form-select form-control" v-model="reward_type.reward_type_setting.reward_set_amount_type" style="width: 45%;">
                                  <option value="P">% (percentage)</option>
                                  <option value="C">₦ (cash)</option>
                                </select>
                              </div>
                              </label>
                              <div class="loading-sm" v-if="action_loading"></div>
                              <p style="color:#ff0000;">{{data_processing_message}}</p>
                              <button :disabled="disable_btn" type="button" class="btn" @click="postBusinessRewardSettings(reward_type)" v-if="menu_tab_inner_view['set'+reward_type.reward_type_name+reward_type.reward_type_id]">Save</button>
                              <button :disabled="disable_btn" type="button" class="btn" @click="updateBusinessRewardSettings(reward_type.reward_type_setting)" v-else>Save</button>
                            </form>
                            <!-- <div v-else> -->
                              <!-- <p><b>Agent Commision:</b> {{sellpoint.business_agent_commission}}</p>
                              <button class="btn sp-button-02 sp-button-md" @click="setMenuTabView('business','editBankDetails','')">Edit</button> -->
                            <!-- </div> -->
                            <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('')" style="float: right;">close</a>
                            <div class="clearfix"></div>
                          <!-- </div> -->
                      </div>
                      <div class="clearfix"></div>
        </div>          
      </div>
      <div>
        <p><b>Turn on Agent Marketing</b>
          <span v-if="(sellpoint.business_is_agents_open == 1)" style="margin-left:1em; color:#ff0000;">ON</span>
          <span v-if="(sellpoint.business_is_agents_open == 0)" style="margin-left:1em; color:#ff0000;">OFF</span>
        </p>
        <p class="p-tiny-info">You must set a Reward amount before turning on this feature</p>
        <div v-if="(set_reward_commission > 0)">
          <div>
            <a v-if="(sellpoint.business_is_agents_open == 1) " class="btn sp-button-02 sp-button-sm" @click="updateBusinessGeneralSettings(1,{})" style="float: right;">TURN OFF</a>
            <a v-else class="btn sp-button-02 sp-button-sm" @click="updateBusinessGeneralSettings(1,{})" style="float: right;">TURN ON</a>
          </div>
        </div>
        <div v-else>
          <div>
            <a v-if="(sellpoint.business_is_agents_open == 1)" class="btn sp-button-02 sp-button-sm" @click="updateBusinessGeneralSettings(1,{})" style="float: right;">TURN OFF</a>
            <a v-else :disabled="true" class="btn sp-button-02 sp-button-sm" style="float: right;">TURN ON</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              //user:this.$store.getters['account/getUser'],
              //business:this.$store.getters['account/getUserBusiness'],
            }
        },

        methods: {
            setPage(){
              this.loading = true;
              //
              this.getBusinessRewardSettings(); 
            },
        },

        components: {},

        created: function(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    self.setPage();
                }else{}
            });
        }

    }
</script>



// WEBPACK FOOTER //
// SellpointRewards.vue?09a6e8ff